<div class="p-col-12 p-lg-12 mb30">
  @if (isLoading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  <p-tabs scrollable value="0">
    <p-tablist>
      <p-tab value="0">All Engagements</p-tab>
      <p-tab value="1">All Engagements Milestone 2</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="p-col-12 p-lg-12 pageheader">
          <div class="fl-right">
            <button
              type="button"
              pButton
              (click)="exportNoPayeeIDPaymentReport()"
              class="ui-button-primary excel-export">
              <span
                >No Payee ID <br />
                Ready for Payment Report
              </span>
            </button>
          </div>
          <div class="fl-right export-btn-first">
            <button
              type="button"
              pButton
              (click)="exportReadyforPaymentReport()"
              class="ui-button-primary excel-export btn-excel-first">
              <span>Ready for Payment Report </span>
            </button>
          </div>
        </div>
        <div class="ui-g card">
          <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
            <p-table
              #pa
              [columns]="cols"
              [scrollable]="true"
              [style]="{ width: '100%' }"
              [value]="downloadCSVList"
              selectionMode="single"
              [loadingIcon]="loadingIcon"
              [showLoader]="true"
              [rowsPerPageOptions]=""
              [paginator]="true"
              [rows]="rowCount"
              paginatorPosition="both">
              <ng-template #header>
                <tr>
                  <th
                    [pSortableColumn]="'fileName'"
                    class="collarge"
                    style="width: 200px">
                    File Name <p-sortIcon [field]="'fileName'"></p-sortIcon>
                  </th>
                  <th
                    [pSortableColumn]="'createdOn'"
                    class="collarge"
                    style="width: 200px">
                    File Created on (PST)
                    <p-sortIcon [field]="'createdOn'"></p-sortIcon>
                  </th>
                  <th class="colsmall" style="text-align: center">
                    Download CSV
                  </th>
                </tr>
                <tr></tr
              ></ng-template>
              <ng-template #body let-downloadCSVList let-columns="columns">
                <tr>
                  <td class="collarge" style="width: 200px">
                    {{ downloadCSVList.fileName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ downloadCSVList.createdOn }}
                  </td>
                  <td class="colsmall text-center">
                    <button
                      (click)="downloadFile(downloadCSVList)"
                      tooltipPosition="top"
                      pTooltip="{{ downloadCSVList.fileName }}"
                      class="edit-button-link">
                      <i
                        class="fa fa-file-excel-o"
                        aria-hidden="true"
                        style="font-size: 16px"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="p-col-12 p-lg-12 pageheader">
          <div class="fl-right export-btn-first">
            <button
              type="button"
              pButton
              (click)="exportAllEngagementsMilestone2()"
              class="ui-button-primary excel-export">
              <span
                >Export All Engagements <br />
                Milestone 2</span
              >
            </button>
          </div>
        </div>
        <div class="ui-g card">
          <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
            <p-table
              #dt
              [columns]="m2Cols"
              [scrollable]="true"
              [style]="{ width: '100%' }"
              [value]="programPaymentFeedData"
              [loadingIcon]="loadingIcon"
              [showLoader]="true"
              [loading]="isLoading"
              [rows]="rowCount"
              paginatorPosition="both"
              [paginator]="true"
              [rowsPerPageOptions]="">
              <ng-template #header>
                <tr>
                  <th
                    class="collarge"
                    *ngFor="let column of m2Cols"
                    style="width: 200px">
                    {{ column.header }}
                  </th>
                </tr>
              </ng-template>
              <ng-template
                #body
                let-programPaymentFeedData
                let-columns="columns">
                <tr>
                  <ng-container *ngFor="let column of m2Cols">
                    @if (!column.calculatedValueHTML && column.isDateFormat) {
                      <td class="collarge" style="width: 200px">
                        {{
                          programPaymentFeedData[column.field]
                            | date: dateFormat
                        }}
                      </td>
                    }
                    @if (!column.calculatedValueHTML && !column.isDateFormat) {
                      <td class="collarge" style="width: 200px">
                        {{ programPaymentFeedData[column.field] }}
                      </td>
                    }
                    @if (column.calculatedValueHTML) {
                      <td class="collarge" style="width: 200px">
                        <div
                          [innerHTML]="
                            getCalculatedValue(
                              programPaymentFeedData,
                              column.field
                            )
                          "></div>
                      </td>
                    }
                  </ng-container>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
